import { render, staticRenderFns } from "./LocationResults.vue?vue&type=template&id=91355e10&scoped=true"
import script from "./LocationResults.vue?vue&type=script&lang=js"
export * from "./LocationResults.vue?vue&type=script&lang=js"
import style0 from "./LocationResults.vue?vue&type=style&index=0&id=91355e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91355e10",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonIcon: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/common/Icon/index.vue').default})
